// extracted by mini-css-extract-plugin
module.exports = {"signalIcon":"Signal_signalIcon__3kspy","label":"Signal_label__35Lkk"};